import { sortByOrderInPlace } from "@/common/utils.sort";
import { removeElementFromArray } from "@/common/utils.array";

import eventAction from "@/store/eventAction";

import { lastOrDefault } from "@/common/utils.array";

import utilsOrder from "@/common/utils.order";

import cache from "@/store/cache";

function defaultState() {
  return {};
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  socket_lists({ commit }, data) {
    if (data.lists) {
      commit(
        "ADD_RANGE",
        data.lists.map(list => {
          return {
            board: cache.boards.byId(list.board_id),
            list: list
          };
        })
      );
    }

    if (data.botRiotLists) {
      commit(
        "botRiotLists/ADD_RANGE",
        data.botRiotLists.map(botRiotList => {
          return {
            list: cache.lists.byId(botRiotList.list_id),
            botRiotList: botRiotList
          };
        }),
        { root: true }
      );
    }

    if (data.alarms) {
      commit(
        "alarms/ADD_RANGE",
        data.alarms.map(alarm => {
          return {
            list: cache.lists.byId(alarm.list_id),
            alarm: alarm
          };
        }),
        { root: true }
      );
    }
  },

  new({ dispatch }, { board, title }) {
    dispatch(
      "events/emit",
      {
        board: board,
        action: eventAction.list.new,
        data: title
      },
      { root: true }
    );
  },

  editTitle({ dispatch }, { list, title }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.list.title.edit,
        list: list,
        data: title
      },
      { root: true }
    );
  },

  editRobotUrl({ dispatch }, { list, robot_url }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.list.robotUrl.edit,
        list: list,
        data: robot_url
      },
      { root: true }
    );
  },

  moveCardsTo({ dispatch }, { list, newList }) {
    if (!list || !newList) return;

    let newOrder = utilsOrder.default();
    const lastCard = lastOrDefault(newList.cards);
    if (lastCard) {
      newOrder = utilsOrder.next(lastCard.order);
    }

    const copy = list.cards.slice(0);
    copy.forEach(card => {
      dispatch(
        "cards/move",
        {
          list: newList,
          card: card,
          order: newOrder
        },
        { root: true }
      );

      newOrder = utilsOrder.next(newOrder);
    });
  },

  move({ dispatch }, { list, order }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.list.move,
        board: cache.boards.byId(list.board_id),
        list: list,
        data: order
      },
      { root: true }
    );
  },

  archive({ dispatch }, list) {
    dispatch(
      "events/emit",
      {
        action: eventAction.list.archive,
        board: cache.boards.byId(list.board_id),
        list: list
      },
      { root: true }
    );
  },

  dearchive({ dispatch }, list) {
    dispatch(
      "events/emit",
      {
        action: eventAction.list.dearchive,
        board: cache.boards.byId(list.board_id),
        list: list
      },
      { root: true }
    );
  },

  handleEvent({ rootState, commit }, event) {
    const requirements = eventAction.requireFor(rootState, event);
    if (!requirements) return;

    const board = requirements.board;
    const list = requirements.list;

    switch (event.action) {
      case eventAction.list.new: {
        const newList = {
          id: event.list_id,
          board_id: requirements.board.id,
          title: event.data,
          user_id: event.user_id,
          order: event.data2,
          date: event.date
        };

        commit("ADD", {
          board: board,
          list: newList
        });
        break;
      }
      case eventAction.list.title.edit: {
        list.title = event.data;
        break;
      }

      case eventAction.list.robotUrl.edit: {
        list.robot_url = event.data;
        break;
      }

      case eventAction.list.move: {
        if (event.data) {
          list.order = event.data;
          if (board) {
            sortByOrderInPlace(board.lists);
          }
        } else {
          console.error("moveList must has data!");
        }
        break;
      }
      case eventAction.list.archive: {
        commit("ARCHIVE", {
          board: board,
          list: list,
          status: true
        });
        break;
      }
      case eventAction.list.dearchive: {
        commit("ARCHIVE", {
          board: board,
          list: list,
          status: false
        });
        break;
      }
    }
  }
};

function add(state, board, list) {
  if (!list) return;

  if (!list.id) {
    console.error("Cant add list without id", list);
    return;
  }

  cache.lists.tryAdd(list);

  if (!board) {
    console.error("board is not existing for list", list);
    return;
  }

  if (!list.board_id) list.board_id = board.id;

  if (list.archived) {
    if (!board.archive.lists.find(l => l.id == list.id)) {
      board.archive.lists.push(list);
    }
  } else {
    if (!board.lists.find(l => l.id == list.id)) {
      board.lists.push(list);
      sortByOrderInPlace(board.lists);
    }
  }
}

// mutations
const mutations = {
  ADD_RANGE(state, items /* [{ board, list }] */) {
    items.forEach(i => {
      add(state, i.board, i.list);
    });
  },
  ADD(state, { board, list }) {
    add(state, board, list);
  },
  ARCHIVE(state, { board, list, status }) {
    if (!list) return;

    if (!list.id) {
      console.error("Cant archive list without id", list);
      return;
    }

    if (!board) {
      console.error("board is not existing for list", list);
      return;
    }

    list.archived = status;
    if (status) {
      removeElementFromArray(board.lists, list);
      if (!board.archive.lists.some(c => c.id == list.id)) {
        //it can be already in this board
        board.archive.lists.push(list);
      }
    } else {
      removeElementFromArray(board.archive.lists, list);
      if (!board.lists.some(c => c.id == list.id)) {
        //it can be already in this board
        board.lists.push(list);
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
